import { Injectable } from '@angular/core';
import { Http ,Response ,Headers, RequestOptions} from '@angular/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CartService {

  public api_url: string = environment.apiUrl;
  public app_url: string = environment.imageUrl;

  constructor(private _http: Http) { }

  addToCart(data){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({ 'Accept': 'application/json','Authorization': token });
    var options = new RequestOptions({ headers: headers_new });
    return this._http.post(this.api_url + 'addcart',data,options).pipe(map((res: Response) => res.json()));
  }

  addNewCartForVip(data){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({ 'Accept': 'application/json','Authorization': token });
    var options = new RequestOptions({ headers: headers_new });
    return this._http.post(this.api_url + 'addnewcartfor-vip' , data ,options).pipe(map((res: Response) => res.json()));
  }

  getUserCartData(data){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({ 'Accept': 'application/json','Authorization': token });
    var options = new RequestOptions({ headers: headers_new });
    return this._http.post(this.api_url + 'getcart' , data ,options).pipe(map((res: Response) => res.json()));
  }

  editInUsercart(data,cart_id){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({ 'Accept': 'application/json','Authorization': token });
    var options = new RequestOptions({ headers: headers_new });
    return this._http.put(this.api_url + 'updatecart/' + cart_id ,data ,options).pipe(map((res: Response) => res.json()));
  }

  deleteInUserCart(newdata){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({ 'Accept': 'application/json','Authorization': token });
    var options = new RequestOptions({ headers: headers_new });
    return this._http.post(this.api_url + 'deleteshisha', newdata ,options).pipe(map((res: Response) => res.json()));
  }

  deletePackageInUserCart(newdata){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({ 'Accept': 'application/json','Authorization': token });
    var options = new RequestOptions({ headers: headers_new });
    return this._http.post(this.api_url+ 'deletePackage', newdata, options).pipe(map((res: Response) => res.json()));
  }

  addBilling(data){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({ 'Accept': 'application/json','Authorization': token });
    var options = new RequestOptions({ headers: headers_new });
    return this._http.post(this.api_url + 'billing',data,options).pipe(map((res: Response) => res.json()));
  }

  getBilling(user_id){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({ 'Accept': 'application/json','Authorization': token });
    var options = new RequestOptions({ headers: headers_new });
    return this._http.get(this.api_url + 'billing/'+ user_id ,options).pipe(map((res: Response) => res.json()));
  }

  checkVenueWithItemInCart(data){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({ 'Accept': 'application/json','Authorization': token });
    var options = new RequestOptions({ headers: headers_new });
    return this._http.post(this.api_url + 'checkVenueWithItemInCart',data ,options).pipe(map((res: Response) => res.json()));
  }

  deleteCustomerCartData(data){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({ 'Accept': 'application/json','Authorization': token });
    var options = new RequestOptions({ headers: headers_new });
    return this._http.post(this.api_url + 'deleteCustomerCartData',data ,options).pipe(map((res: Response) => res.json()));
  }

  editCustomerCartData(data){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({ 'Accept': 'application/json','Authorization': token });
    var options = new RequestOptions({ headers: headers_new });
    return this._http.get(this.api_url + 'editCustomerCartData/'+data ,options).pipe(map((res: Response) => res.json()));
  }

  updateCustomerCartData(data){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({ 'Accept': 'application/json','Authorization': token });
    var options = new RequestOptions({ headers: headers_new });
    return this._http.post(this.api_url + 'updateCustomerCartData',data ,options).pipe(map((res: Response) => res.json()));
  }

  addUpdateCustomerCartData(data){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({
      'Accept': 'application/json',
      'Authorization': token
    });
    var options = new RequestOptions({
      headers: headers_new
    });
    return this._http.post(this.api_url + 'addUpdateCartData', data, options).pipe(map((res: Response)=>res.json()));
  }

  searchBarData(data){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({ 'Accept': 'application/json','Authorization': token });
    var options = new RequestOptions({ headers: headers_new });
    return this._http.post(this.app_url + 'setUrl',data ,options).pipe(map((res: Response) => res.json()));
  }

  checkParentCart(data){
    let token = localStorage.getItem('token');
    let header_new = new Headers({
      'Accept': 'application/json',
      'Authorization': token
    });
    let options = new RequestOptions({
      headers: header_new,
    });
    return this._http.post(this.api_url + 'checkParentCart', data, options).pipe(map((res:Response)=>res.json()));
  }

  updateGuest(data){
    let token = localStorage.getItem('token');
    let header_new = new Headers({
      'Accept': 'application/json',
      'Authorization': token
    });
    let options = new RequestOptions({
      headers: header_new
    });
    return this._http.post(this.api_url+'updateTotalPerson', data, options).pipe(map((res:Response)=>res.json()));
  }
  updateGuestDetail(data){
    let token = localStorage.getItem('token');
    let header_new = new Headers({
      'Accept': 'application/json',
      'Authorization': token
    });
    let options = new RequestOptions({
      headers: header_new
    });
    return this._http.post(this.api_url+'updateGuestDetail', data, options).pipe(map((res:Response)=>res.json()));
  }

  addGuestCartData(data){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({
      'Accept': 'application/json',
      'Authorization': token
    });
    var options = new RequestOptions({
      headers: headers_new
    });
    return this._http.post(this.api_url + 'addGuestCart', data, options).pipe(map((res: Response)=>res.json()));
  }

  addDeliveryAddressToCart(data){
    var token = localStorage.getItem('token');
    var header_new = new Headers({ 'Accept': 'application/json','Authorization': token });

    var options = new RequestOptions({
                        headers: header_new
                      });

    return this._http.post(this.api_url + 'addUserAddressForTakeawayOrder',data, options).pipe(map((res: Response) => res.json()));
  }

  getUserAddress(data){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({ 'Accept': 'application/json','Authorization': token });
    var options = new RequestOptions({ headers: headers_new });
    return this._http.get(this.api_url + 'getCurrentUserAddress/'+data ,options).pipe(map((res: Response) => res.json()));
  }

  get_delivery_time_based_minimum_order_value(data){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({ 'Accept': 'application/json','Authorization': token });
    var options = new RequestOptions({ headers: headers_new });
    return this._http.post(this.api_url + 'getDeliveryTimeBasedMinimumOrderValue', data, options).pipe(map((res: Response) => res.json()));
  }

  update_is_checkout_status_on_cart(data){
    var token = localStorage.getItem('token');
    var header_new = new Headers({ 'Accept': 'application/json','Authorization': token });

    var options = new RequestOptions({
                        headers: header_new,
                        params: {
                          cart_id: data.cart_id,
                          is_checkout: data.is_checkout,
                        }
                      });

    return this._http.get(this.api_url + 'updateIsCheckoutStatusOnCart',options).pipe(map((res: Response) => res.json()));
  }

  check_split_bill_parent_cart(data){
    let token = localStorage.getItem('token');
    let header_new = new Headers({
      'Accept': 'application/json',
      'Authorization': token
    });
    let options = new RequestOptions({
      headers: header_new,
    });
    return this._http.post(this.api_url + 'checkSplitBillParentCart', data, options).pipe(map((res:Response)=>res.json()));
  }

  get_cart_total_prices(data){
    let token = localStorage.getItem('token');
    let header_new = new Headers({
      'Accept': 'application/json',
      'Authorization': token
    });
    let options = new RequestOptions({
      headers: header_new,
    });
    return this._http.post(this.api_url + 'getCartTotalPrice', data, options).pipe(map((res:Response)=>res.json()));
  }

  night_club_get_cart_total_prices(data){
    let token = localStorage.getItem('token');
    let header_new = new Headers({
      'Accept': 'application/json',
      'Authorization': token
    });
    let options = new RequestOptions({
      headers: header_new,
    });
    return this._http.post(this.api_url + 'nightclub/getCartTotalPrice', data, options).pipe(map((res:Response)=>res.json()));
  }

  userGenderChange(data){
    var token = localStorage.getItem('token');
    var headers_new = new Headers({ 'Accept': 'application/json','Authorization': token });
    var options = new RequestOptions({ headers: headers_new });
    return this._http.post(this.api_url + 'changeUserGender' , data ,options).pipe(map((res: Response) => res.json()));
  }
}
